import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './style.css';
import _ from 'lodash';
import {
  ShimmerCategoryItem,
  ShimmerThumbnail,
  ShimmerSectionHeader,
  ShimmerButton,
  ShimmerTitle,
  ShimmerSimpleGallery,
  ShimmerSocialPost,
  ShimmerText,
  ShimmerPostDetails
} from 'react-shimmer-effects';
import { SHIMMER_ITEMS } from '../../../constants/section-constants/common-constants';

const AppShimmer = props => {
  const {
    // state
    deviceSize,

    // component
    source = 'default',
    repeatTime = 5,
    height = `100%`
  } = props;

  const _renderShimmer = (type = source, repeatCount = repeatTime) => {
    switch (type) {
      case SHIMMER_ITEMS.agenda:
        return (
          <div className="w-100">
            <div
              className="d-flex- d-none justify-content-center w-100 border-bottom p-2"
              style={{ gap: '10px', height: '55px' }}
            >
              {_.times(3, ea => {
                return (
                  <ShimmerButton key={`${type}_shimmer_${ea}`} size="md" />
                );
              })}
            </div>
            <div
              className="d-flex w-100 border-bottom p-2"
              style={{ gap: '10px', height: '55px' }}
            >
              {_.times(5, ea => {
                return (
                  <ShimmerButton key={`${type}_shimmer_${ea}`} size="md" />
                );
              })}
            </div>
            <div className="row m-0">
              <div
                className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 border-right pt-1 pl-0 pr-0 scrollable-content"
                style={{
                  height: deviceSize.height - 193
                }}
              >
                {_renderShimmer(SHIMMER_ITEMS.sessionlist)}
              </div>
            </div>
          </div>
        );

      case SHIMMER_ITEMS.chats:
        return (
          <div className="w-100">
            {_.times(repeatCount, ea => {
              let rearrange = ea == 1;
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className={`d-flex ${
                    rearrange ? 'flex-row-reverse' : ''
                  } p-2`}
                  style={{ gap: '20px' }}
                >
                  <ShimmerThumbnail
                    height={60}
                    rounded
                    className={'userRounded-thumbnail'}
                  />
                  <div
                    className={`w-100 d-flex  ${
                      rearrange ? 'align-items-end flex-column-reverse' : ''
                    } flex-column`}
                  >
                    <ShimmerButton size={rearrange ? 'sm' : 'lg'} />
                    <ShimmerButton size="md" />
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.eventguide:
        return (
          <div className="w-100">
            {_.times(repeatCount, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="d-flex whiteBgBorder10"
                  style={{ gap: '10px' }}
                >
                  <ShimmerThumbnail
                    height={60}
                    rounded
                    className={'exhibitorList-thumbnail mb-0'}
                  />
                  <ShimmerTitle
                    line={1}
                    className={'mt-3 w-100'}
                    variant="primary"
                  />
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.eventguideDetails:
      case SHIMMER_ITEMS.webView:
        return (
          <div className="w-100">
            <ShimmerPostDetails card cta variant="EDITOR" />
          </div>
        );

      case SHIMMER_ITEMS.notes:
        return (
          <div className="w-100 p-2 mt-2">
            {_.times(repeatCount, ea => (
              <div key={`${type}_shimmer_${ea}`}>
                <ShimmerTitle line={1} className={'mb-2'} variant="secondary" />
                <div className="d-flex justify-content-between mb-3">
                  {_.times(2, eaI => {
                    return (
                      <ShimmerTitle
                        key={`${type}_shimmer_item_${eaI}`}
                        line={1}
                        className={'my-2 w-25'}
                        variant="secondary"
                      />
                    );
                  })}
                  <ShimmerButton size="sm" />
                </div>
              </div>
            ))}
          </div>
        );

      case SHIMMER_ITEMS.noteDetails:
        return (
          <div className="w-100 px-3">
            <ShimmerTitle line={1} className={'mt-3 w-50'} variant="primary" />
            <ShimmerThumbnail height={100} rounded className={'mb-3  w-25'} />
            <ShimmerThumbnail height={200} rounded className={'mb-2  w-65'} />
          </div>
        );

      case SHIMMER_ITEMS.news:
      case SHIMMER_ITEMS.maps:
        return (
          <div className={`w-100 ${deviceSize?.isMobile ? 'px-5' : ''}`}>
            <ShimmerSimpleGallery
              card
              imageHeight={150}
              col={deviceSize?.isMobile ? 12 : 4}
              caption
            />
          </div>
        );

      case SHIMMER_ITEMS.newsDetails:
        return (
          <div className="w-100">
            <ShimmerThumbnail height={500} rounded className={'mb-2'} />
            <div style={{ height: '40px' }}>
              <ShimmerButton size="lg" />
            </div>
            <ShimmerTitle variant="secondary" className={'mb-4'} />
            <ShimmerText line={3} gap={10} />
          </div>
        );

      case SHIMMER_ITEMS.mapDetails:
        return (
          <div className="w-100">
            <ShimmerThumbnail height={500} rounded />
          </div>
        );

      case SHIMMER_ITEMS.gallery:
        return (
          <div className="w-100">
            <ShimmerSimpleGallery
              col={deviceSize.isMobile ? 3 : 4}
              card
              imageHeight={220}
            />
          </div>
        );

      case SHIMMER_ITEMS.scans:
        return (
          <div className="w-100 p-3 ">
            {_.times(repeatCount, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="d-flex whiteBgBorder10"
                  style={{ gap: '10px' }}
                >
                  <ShimmerThumbnail
                    height={60}
                    rounded
                    className={'userRounded-thumbnail'}
                  />
                  <div className="w-100">
                    <ShimmerTitle
                      line={2}
                      className={'my-2'}
                      gap={10}
                      variant="secondary"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.notifications:
        return (
          <div className="w-100 p-3 ">
            {_.times(repeatCount, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="d-flex"
                  style={{ gap: '10px' }}
                >
                  <ShimmerThumbnail
                    height={60}
                    rounded
                    className={'userRounded-thumbnail'}
                  />
                  <div className="w-100">
                    <ShimmerTitle
                      line={1}
                      className={'my-2'}
                      gap={10}
                      variant="secondary"
                    />
                    <ShimmerText line={2} className={'mb-3'} gap={10} />
                    <ShimmerText line={1} />
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.sessiondates:
        return (
          <div
            className="d-flex w-100 border-bottom p-2"
            style={{ gap: '10px', height: '55px' }}
          >
            {_.times(repeatCount, ea => {
              return <ShimmerButton key={`${type}_shimmer_${ea}`} size="md" />;
            })}
          </div>
        );

      case SHIMMER_ITEMS.sessionlist:
        return (
          <div className="w-100 p-3">
            {_.times(repeatCount, ea => (
              <div
                key={`${type}_shimmer_${ea}`}
                className="mb-2 whiteBgBorder10"
              >
                <ShimmerTitle variant="primary" className={'mb-2'} />
                <ShimmerText line={1} className={'mb-2'} />
                <div style={{ height: '40px' }}>
                  <ShimmerButton size="md" />
                </div>
              </div>
            ))}
          </div>
        );

      case SHIMMER_ITEMS.sessionCalendar:
        return (
          <div className="w-100 p-3 pt-4 d-flex" style={{ height }}>
            <section style={{ width: 80, height }}>
              {_.times(repeatCount, ea => (
                <div
                  key={`${type}_shimmer_part1_${ea}`}
                  className="d-flex justify-content-center position-relative"
                  style={{ height: height / 5, width: 80 }}
                >
                  <div className="position-absolute" style={{ top: -8 }}>
                    <ShimmerButton size="sm" />
                  </div>
                </div>
              ))}
            </section>
            <section style={{ width: '80%', height }}>
              {_.times(repeatCount, ea => (
                <div
                  key={`${type}_shimmer_part2_${ea}`}
                  className="border-top"
                  style={{ height: height / 5 }}
                ></div>
              ))}
            </section>
          </div>
        );

      case SHIMMER_ITEMS.sessionpolls:
        return (
          <div className="w-100">
            {_.times(repeatCount, ea => (
              <div
                key={`${type}_shimmer_${ea}`}
                className="w-100 whiteBgBorder10"
              >
                <ShimmerTitle line={1} className={'mb-2'} variant="primary" />
                <div
                  className="d-flex justify-content-center border-top p-2"
                  style={{ height: '45px' }}
                >
                  <ShimmerButton size="md" />
                </div>
              </div>
            ))}
          </div>
        );

      case SHIMMER_ITEMS.communitylists:
        return (
          <div className="w-100 py-2">
            {_.times(repeatCount, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="mb-2 p-2 rounded bg-white"
                >
                  <div className="d-flex" style={{ gap: '10px' }}>
                    <ShimmerThumbnail
                      height={60}
                      rounded
                      className={'exhibitorList-thumbnail mb-2'}
                    />
                    <div className="w-100">
                      <ShimmerTitle
                        line={2}
                        className={'mb-2'}
                        variant="secondary"
                      />
                      <ShimmerText line={1} className={'mb-2'} />
                    </div>
                  </div>
                  <div
                    className="d-flex border-top pt-2"
                    style={{ gap: '20px', height: '45px' }}
                  >
                    {_.times(3, eaI => {
                      return (
                        <ShimmerButton
                          key={`${type}_shimmer_item_${eaI}`}
                          size="md"
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.communitypostDetails:
      case SHIMMER_ITEMS.liveQaPosts:
        return (
          <div className="w-100  px-1">
            {_.times(repeatCount, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="whiteBgBorder10 mb-2"
                >
                  <div className="d-flex " style={{ gap: '10px' }}>
                    <ShimmerThumbnail
                      height={60}
                      rounded
                      className={'userRounded-thumbnail'}
                    />
                    <div className="w-100">
                      <ShimmerTitle className={'mb-2'} variant="secondary" />
                    </div>
                  </div>
                  <ShimmerTitle
                    line={1}
                    className={'mb-2'}
                    variant="secondary"
                  />
                  <ShimmerText line={2} className={'mb-3'} gap={10} />
                  <div
                    className="d-flex border-top py-2 justify-content-between"
                    style={{ height: '40px' }}
                  >
                    <ShimmerButton size="sm" />
                    <ShimmerButton size="sm" />
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.comments:
      case SHIMMER_ITEMS.gamificationChallenges:
        return (
          <div className="w-100  px-1">
            {_.times(repeatCount, ea => {
              return (
                <div key={`${type}_shimmer_${ea}`} className="mb-2">
                  <div
                    className="d-flex whiteBgBorder10"
                    style={{ gap: '10px' }}
                  >
                    <ShimmerThumbnail
                      height={60}
                      rounded
                      className={'userRounded-thumbnail'}
                    />
                    <div className="w-100">
                      <ShimmerTitle className={'mb-2'} variant="secondary" />
                      <ShimmerText line={1} className={'mb-3'} gap={10} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.gamificationLeaderboard:
        return (
          <div className="w-100">
            {_.times(repeatCount, ea => (
              <div
                key={`${type}_shimmer_${ea}`}
                className="d-flex w-100 justify-content-between align-items-center"
                style={{
                  gap: '40px'
                }}
              >
                <ShimmerThumbnail
                  height={60}
                  rounded
                  className={'userRounded-thumbnail mb-0'}
                />
                <ShimmerTitle
                  line={1}
                  variant={'primary'}
                  className={'w-100 mb-0'}
                  gap={10}
                />
                <div style={{ height: '30px' }}>
                  <ShimmerButton size="sm" />
                </div>
              </div>
            ))}
          </div>
        );

      case SHIMMER_ITEMS.userChat:
        return (
          <div className="w-100">
            {_.times(repeatCount, ea => (
              <div
                key={`${type}_shimmer_${ea}`}
                className="d-flex w-100 justify-content-between align-items-center whiteBgBorder10"
                style={{
                  gap: _.isEqual(type, SHIMMER_ITEMS.userChat) ? '10px' : '40px'
                }}
              >
                <ShimmerThumbnail
                  height={60}
                  rounded
                  className={'userRounded-thumbnail mb-0'}
                />
                <ShimmerTitle
                  line={_.isEqual(type, SHIMMER_ITEMS.userChat) ? 2 : 1}
                  variant={
                    _.isEqual(type, SHIMMER_ITEMS.userChat)
                      ? 'secondary'
                      : 'primary'
                  }
                  className={'w-100 mb-0'}
                  gap={10}
                />
                <div style={{ height: '30px' }}>
                  <ShimmerButton size="sm" />
                </div>
              </div>
            ))}
          </div>
        );

      case SHIMMER_ITEMS.calendar:
        return (
          <div className="w-100 d-flex flex-column mt-2 align-items-center justify-content-center">
            <ShimmerButton size="md" />

            <div className="d-flex" style={{ gap: '10px' }}>
              {_.times(3, ea => (
                <ShimmerButton
                  key={`${type}_shimmer_button_${ea}`}
                  size={ea == 1 ? 'md' : 'sm'}
                />
              ))}
            </div>
            {_.times(6, ea => (
              <div
                key={`${type}_shimmer_${ea}`}
                className="d-flex"
                style={{ gap: '10px' }}
              >
                {_.times(7, ea => (
                  <div key={`${type}_shimmer_item_${ea}`} className="calender">
                    <ShimmerButton size="sm" />
                  </div>
                ))}
              </div>
            ))}
          </div>
        );

      case SHIMMER_ITEMS.attendeelists:
        return (
          <div className="w-100 p-3 ">
            {_.times(repeatCount, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="d-flex whiteBgBorder10"
                  style={{ gap: '10px' }}
                >
                  <ShimmerThumbnail
                    height={60}
                    rounded
                    className={'userRounded-thumbnail'}
                  />
                  <div className="w-100">
                    <ShimmerTitle className={'mb-2'} variant="secondary" />
                    <div style={{ height: '40px' }}>
                      <ShimmerButton size="sm" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.attendeeDetails:
        return (
          <div className="w-100">
            <div className=" whiteBgBorder10  m-0">
              <div className="d-flex" style={{ gap: '10px' }}>
                <ShimmerThumbnail
                  height={80}
                  rounded
                  className={'userRounded-bigthumbnail'}
                />
                <div className="w-100">
                  <ShimmerTitle className={'mb-2'} variant="primary" />
                  <ShimmerButton size="sm" />
                </div>
              </div>
              <div className="d-flex " style={{ gap: '10px' }}>
                {_.times(2, ea => (
                  <ShimmerButton key={`${type}_shimmer_${ea}`} size={'lg'} />
                ))}
              </div>
            </div>

            {_.times(2, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="m-3 whiteBgBorder10"
                >
                  <ShimmerCategoryItem />
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.socialPoll:
        return (
          <div className="w-100 ">
            {_.times(4, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="d-flex"
                  style={{ gap: '10px' }}
                >
                  <ShimmerThumbnail
                    height={30}
                    rounded
                    className={'social-poll mt-2'}
                  />
                  <div className="w-100">
                    <ShimmerButton size={'lg'} />
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.socialPosts:
        return (
          <div className="w-100 mt-2 px-1">
            <ShimmerSocialPost type="both" />
          </div>
        );

      case SHIMMER_ITEMS.speakerlist:
        return (
          <div className="w-100 ">
            {_.times(repeatCount, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="d-flex"
                  style={{ gap: '10px' }}
                >
                  <ShimmerThumbnail
                    height={80}
                    rounded
                    className={'exhibitorList-thumbnail'}
                  />
                  <div className="w-100">
                    <ShimmerTitle
                      line={1}
                      className={'mb-2'}
                      variant="primary"
                    />
                    <ShimmerTitle line={2} variant="secondary" />
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.speakerDetails:
        return (
          <div className="w-100 ">
            <ShimmerThumbnail height={300} rounded className={'mb-3'} />
            {_.times(2, ea => {
              return (
                <div key={`${type}_shimmer_${ea}`} className="px-2 ">
                  <ShimmerCategoryItem />
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.surveyList:
        return (
          <div className="w-100">
            {_.times(repeatCount, ea => (
              <div key={`${type}_shimmer_${ea}`} className="px-2">
                <ShimmerCategoryItem
                  hasImage
                  imageType="thumbnail"
                  imageWidth={50}
                  imageHeight={50}
                  title
                />
              </div>
            ))}
          </div>
        );

      case SHIMMER_ITEMS.exhibitorlist:
      case SHIMMER_ITEMS.sponsorlist:
        return (
          <div className="w-100 p-3 ">
            {_.times(repeatCount, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="d-flex"
                  style={{ gap: '10px' }}
                >
                  <ShimmerThumbnail
                    height={60}
                    rounded
                    className={'exhibitorList-thumbnail'}
                  />
                  <div className="w-100">
                    <ShimmerTitle
                      line={1}
                      className={'mb-2'}
                      variant="secondary"
                    />
                    <ShimmerText line={2} gap={10} />
                  </div>
                </div>
              );
            })}
          </div>
        );

      case SHIMMER_ITEMS.exhibitorDetails:
      case SHIMMER_ITEMS.sponsorDetails:
        return (
          <div className="w-100">
            <ShimmerThumbnail height={250} rounded />
            <div className="px-2">
              <ShimmerCategoryItem
                hasImage
                imageWidth={100}
                imageHeight={100}
                title
              />
              {_.isEqual(type, 'exhibitorDetails') && (
                <>
                  <ShimmerButton size="lg" />
                  <div className="d-flex mb-3" style={{ gap: '20px' }}>
                    {_.times(4, ea => {
                      return (
                        <ShimmerButton
                          key={`${type}_shimmer_${ea}`}
                          size="md"
                        />
                      );
                    })}
                  </div>
                  <ShimmerCategoryItem />
                </>
              )}
              {_.times(2, ea => {
                return <ShimmerCategoryItem key={`${type}_shimmer_${ea}`} />;
              })}
            </div>
          </div>
        );

      case SHIMMER_ITEMS.sideBar:
        return (
          <div className="w-100">
            {_.times(repeatCount, ea => {
              return (
                <div
                  key={`${type}_shimmer_${ea}`}
                  className="sidebar-menu-shimmer"
                >
                  <ShimmerThumbnail
                    height={30}
                    width={30}
                    rounded
                    className={''}
                  />
                  <ShimmerTitle line={1} className={''} variant="primary" />
                </div>
              );
            })}
          </div>
        );

      default:
        return (
          <div className="w-100 p-3">
            <ShimmerSectionHeader />
            <ShimmerSectionHeader />
          </div>
        );
    }
  };

  return (
    <div className="d-flex" style={{ flexGrow: 1, height }}>
      {_renderShimmer()}
    </div>
  );
};

const mapStateToProps = state => ({
  deviceSize: state.deviceSize
});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AppShimmer);
